<template>
  <div class="DarkWhite pa-4 ">
      <h2 class="subheading green--text">Item Category Utility</h2>
      <v-card class="mt-4">
      <PSUitemcategory/>
  </v-card>
  </div>
</template>

<script>
import PSUitemcategory from '../components/Utils/PSUitemcategory.vue'
  export default {
    components: {
      PSUitemcategory
    },
    data: () => ({
    }),
  }
</script>


<style scoped>
</style>